/**
 * Which route serves a campaign-page read for each tracker. Tres Commas answers
 * the Voluum routes' twins under /tres-commas (same query, same answer), so it
 * shares Voluum's request code with another path. Binom has its own shapes.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { QueryKey } from '@tanstack/react-query';
import { matchTracker } from '@trafficpulse/shared';

import { binomKeys } from '@/hooks/binom/useBinom';
import { tresCommasKeys } from '@/hooks/tres-commas/keys';
import { voluumKeys, type CampaignProvider } from '@/hooks/voluum/useVoluum';

import { dispatchTracker } from './tracker-dispatch';

/** GET path of the Voluum-shape `/reports` read; null for Binom, which has none. */
export function voluumShapeReportsPath(provider: CampaignProvider): string | null {
  return matchTracker<string | null>(dispatchTracker(provider), {
    voluum: () => '/voluum/reports',
    binom: () => null,
    'tres-commas': () => '/tres-commas/reports',
  });
}

/** GET path of the Flows tab's path × lander × offer metrics cube. */
export function flowItemCubePath(provider: CampaignProvider): string {
  return matchTracker(dispatchTracker(provider), {
    voluum: () => '/voluum/reports/flow-item-cube',
    binom: () => '/binom/reports/flow-item-cube',
    'tres-commas': () => '/tres-commas/reports/flow-item-cube',
  });
}

/** Query key of a campaign's flows list (refreshed after a flow save). */
export function campaignFlowsKey(provider: CampaignProvider, campaignId: string): QueryKey {
  return matchTracker<QueryKey>(dispatchTracker(provider), {
    voluum: () => voluumKeys.campaignFlows(campaignId),
    binom: () => binomKeys.campaignFlows(campaignId),
    'tres-commas': () => tresCommasKeys.campaignFlows(campaignId),
  });
}
